// ================ Load data ================ //
// Verification is not run on page load. The user sees the verification page
// and must click the "Verify my email address" button to verify.

export const loadData = () => () => Promise.resolve();
